<template>
  <div class="product-container container">
    <nav class="add-navigation">
      <div @click="$router.push({name: 'system-admin-payment-term-list'})" class="back-link">
        <svg class="icon" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p>Back to Payment Terms</p>
      </div>
      <div class="right-wrapper">
        <search-input
          class="search-input"
          type="text"
          v-model="SearchCompany"
          placeholder="Search for company"
        />
      </div>
    </nav>
    <table class="Invoice_table">
      <thead>
        <tr class="Invoice_table_header">
          <th class="companyName">Company Name</th>
          <th class="balance">Balance</th>
          <th class="postpay">Postpay Credit</th>
          <th class="speace"></th>
          <th class="contact">Contact Person</th>
          <th>Resellers</th>
        </tr>
      </thead>
      <tbody v-if="allcompanies.length > 0">
        <tr
          class="line"
          v-for="(company, k) in allcompanies"
          :key="k"
          :class="{'active': company.status === 'active', 'inactive': company.status === 'inactive'}"
        >
          <th>
            <div class="status"></div>
            <!-- <img
                    class="popup_image"
                    v-if="user.path"
                    :src="`http://88.198.219.62/api_smsc/v1/file/${user.path}`"
                    alt>
            <img class="popup_image" v-else alt>-->
            <img class="popup_image" src="@/assets/person.jpg" alt />
            <span>{{company.companyName}}</span>
          </th>
          <th>${{company.balance}}</th>
          <th>{{company.prepay}}</th>
          <th class="speace"></th>
          <th class="smsText">{{company.contactPerson}}</th>
          <th class="reseller">{{company.resaller}}</th>
        </tr>
      </tbody>
    </table>
    <div class="buttons-wrapper">
      <pagination-component
        @change-page="changePage($event)"
        :page="Page"
        :total="TotalPages"
        :perPage="per_page"
        :qnt="allcompanies.length"
      />
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue")
  },
  data: () => ({
    showDropDown: false,
    allcompanies: [],
    ownCompanies: [],
    companyName: "",
    isApproved: false,
    Page: 0,
    SearchCompany: "",
    TotalPages: null,
    filter: "",
    reseller: "",
    resellers: [],
    per_page: 10
  }),
  created() {
    this.getAllCompanies(this.Searched, this.Page);
  },
  watch: {
    SearchCompany: function() {
      this.getAllCompanies(this.SearchCompany, 0, "company");
    }
  },
  methods: {
    reasetFilters() {
      this.SearchCompany = "";
      this.filter = "";
      this.reseller = "";
      this.getAllCompanies();
    },
    getResellersList() {
      this.$store
        .dispatch("GetResellerList", {
          page: 0,
          search: "",
          perPage: 1000
        })
        .then(res => {
          console.log("res from GetResellerList--->", res);
          this.resellers = res.items;
        });
    },
    approveCompany(id) {
      this.$store
        .dispatch("ApproveCompany", {
          isApproved: true,
          id: id
        })
        .then(res => {
          this.$snotify.success("Company was approved.", {
            timeout: 6000
          });
          this.getAllCompanies();
        });
    },
    changePage(page) {
      this.Page = page;
      this.getAllCompanies(this.Searched, this.Page);
    },
    getAllCompanies(search, page, from) {
      this.$store
        .dispatch("GetCompanyList", {
          page: page,
          paymentTermId: this.$route.params.id,
          company_name: from == "company" ? search : ""
        })
        .then(res => {
          this.Page = res.page;
          this.TotalPages = res.total / res.per_page;
          console.log("res111--->", res);
          this.allcompanies = res.items.map(this.transformCompanies);
        });
    },
    getOwnCompanies() {
      this.$store.dispatch("GetOwnCompanyList").then(res => {
        console.log("res2222--->", res);
        this.ownCompanies = res.items.map(this.transformCompanies);
      });
    },
    transformCompanies(i, k) {
      return {
        companyName: i.company_name,
        balance: i.balance,
        prepay: !i.prepay,
        contactPerson: i.contact.full_name,
        resaller: i.reseller_name,
        companyId: i.company_uuid,
        isApproved: i.is_approved,
        status: i.status
      };
    },
    deleteCompany(companyId) {
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this company!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it"
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch("DeleteCompany", companyId)
            .then(res => {
              console.log("res--->", res);
              this.getAllCompanies();
              this.$swal(
                "Deleted!",
                "Your company has been deleted.",
                "success"
              );
            })
            .catch(err => {
              this.$snotify.error(err.response.statusText);
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.product-container {
  padding: 0 20px;
  .add-navigation {
    align-items: center;
    height: 90px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .right-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      margin-top: 20px;
      .search-input {
        height: 40px;
        width: 345px;
        background-color: #ffffff;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 110px;
      }
    }
  }
}
table.Invoice_table {
  width: 100%;
  margin-top: 21px;
}
table thead tr {
  height: 37px;
  background: #f8f9fe;
  text-align: left;
}
table,
tr {
  width: 100%;
  height: 44px;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}
table tr th {
  padding: 7px 0 7px 0;
}
table {
  border-collapse: collapse;
}
.Invoice_table_header th {
  height: 16px;
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  padding: 11px 0 10px 0;
}
.Invoice_table_header {
  .balance {
    width: 80px;
  }
  .postpay {
    width: 105px;
  }
  .companyName {
    width: 210px;
  }
  .contact {
    width: 130px;
  }
}
.speace {
  width: 15px;
}
.popup_content {
  display: none;
}
.popup_cta {
  cursor: pointer;
}
.btn-link {
  bottom: 10px;
  color: black;
}
.dropdown-menu {
  width: 228px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.1);
  a {
    padding: 10px 15px;
    font-family: "Helvetica Neue";
    font-size: 16px;
    line-height: 20px;
  }
  a:hover {
    color: #51a3f3;
    height: 40px;
    background-color: #f8f9fe;
  }
}
.Invoice_table_popup {
  text-align: right;
  position: relative;
  padding: 0;
  float: right;
  .popup_cta {
    cursor: pointer;
    color: #55616e;
  }
}
tbody th {
  width: fit-content;
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  height: 20px;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  padding: 7px 0 7px 0;
  text-align: left;
  min-width: 70px;
}
table thead th:first-child {
  padding-left: 20px;
}
tbody th:first-child {
  padding: 0;
  span {
    padding: 12px 0;
  }
}
tbody th.created_by {
  line-height: 20px;
  height: 20px;
  padding: 7px 0 27px 0;
}
.Invoice_price {
  font-family: "Helvetica Neue";
  padding: 13px 0 12px 0;
  color: #000000;
  font-weight: bold;
}
.Invoice_table_popup.active .popup_content {
  display: block;
  position: absolute;
  right: 0;
  width: 240px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.1);
  padding-left: 0;
  list-style-type: none;
  text-align: left;
}
.Invoice_table_popup.active .popup_content a {
  color: #55616e;
  font-size: 16px;
  line-height: 20px;
  text-decoration: none;
  font-family: "Helvetica Neue";
  padding: 10px 15px;
  display: inline-block;
}
.popup_image {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin: 0px 8px 0px 0;
}
th.user_active:after {
  content: "";
  height: 10px;
  width: 10px;
  background-color: #24e2b8;
  position: absolute;
  border-radius: 50%;
  left: 12px;
  top: 17px;
  margin: 14px 0 14px 12px;
}

th.user_active {
  text-align: left;
  position: relative;
  padding: 7px 0 7px 0;
}
th.smsText {
  color: #55616e;
  font-family: "Helvetica Neue";
  font-size: 14px;
  font-weight: normal;
  line-height: 25px;
  padding: 7px 0 7px 0;
}
th.status {
  margin: 7px 10px 7px 12px;
  .approved {
    box-sizing: border-box;
    height: 24px;
    width: 80px;
    border: 2px solid #ffffff;
    border-radius: 100px;
    background-color: #24e2b8;
    color: #ffffff;
    font-family: "Helvetica Neue";
    font-size: 13px;
    font-weight: normal;
    line-height: 16px;
    padding: 4px 10px;
  }
  .rejected {
    box-sizing: border-box;
    height: 24px;
    width: 74px;
    border: 2px solid #ffffff;
    border-radius: 100px;
    background-color: #d2305b;
    color: #ffffff;
    font-family: "Helvetica Neue";
    font-size: 13px;
    font-weight: normal;
    line-height: 16px;
    padding: 4px 10px;
  }
}
th.reseller {
  line-height: 25px;
  font-family: "Helvetica Neue";
  color: #000000;
}
th .svg-green {
  cursor: pointer;
  fill: #24e2b8;
  margin-right: 20px;
}
th .svg-red {
  cursor: pointer;
  fill: #d2305b;
}
.Invoice_table_sub_header th {
  height: 30px;
  color: #bdbfd8;
  font-family: "Helvetica Neue";
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 1px;
  line-height: 30px;
  padding: 5px 0 5px 15px;
}
th.allcompanies {
  padding-top: 20px;
}

.status {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-grid;
  margin: 7px 10px 7px 12px;
}

.active {
  th .status {
    background-color: #24e2b8;
  }
}
.inactive {
  background-color: #f0f1fa;
  th .status {
    background-color: #d2305b;
  }
}
</style>

